import React, {Component} from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import ReactTable from 'react-table';

export default class VisitorCountReport extends ReactFireComponent {
  constructor(props) {
    super(props);
    this.dataURL = `visitorLog`;
    this.state = {logs: []}
  }
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'logs');
  }
  componentWillUnmount() {
    this.unbind('logs');
  }
  render() {
    if(!this.state.logs.length === 0) return 'Loading ...';
    const columns = [
      {Header: 'City', accessor: 'city', aggregate: (values, rows) => values[0]},
      {Header: 'Region', accessor: 'region', aggregate: (values, rows) => values[0]},
      {Header: 'Country', accessor: 'country', aggregate: (values, rows) => values[0]},
      {Header: 'Postal Code', accessor: 'postal'},
      {Header: 'Visitors', accessor: 'ip', aggregate: (values, rows) => values.length}
    ]
    const showLogs = this.state.logs
    .filter((userLogs) => userLogs[this.props.expoID] && userLogs[this.props.expoID][this.props.showID])
    .map((userLogs) => userLogs[this.props.expoID][this.props.showID])


    return (
      <div>
        <h3>Visitor Count for the {this.props.name}</h3>
        <h1>{showLogs.length}</h1>
        <p className="info-panel">
          This count may reflect duplicates when the same user
          has logged in from multiple devices or browsers without
          registering for or using an account.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/report-list/visitor-count-report.js